/**
 * Load Vue components and define the routes
 */
import ParamHandler from './../components/ParamHandler.vue'
import AmountInput from './../components/AmountInput.vue'
import InputForm from './../components/InputForm.vue'
import PriceQuote from './../components/PriceQuote.vue'
import AddressInput from './../components/AddressInput.vue'
import EmailInput from './../components/EmailInput.vue'
import BuyerInfoInput from './../components/BuyerInfoInput'
import MobileVerification from './../components/MobileVerification.vue'
import PaymentEtransferInstructions from './../components/PaymentEtransferInstructions.vue'
import PaymentFlexepin from './../components/PaymentFlexepin.vue'
import TransactionInReview from './../components/TransactionInReview.vue'
import TransactionSuccess from './../components/TransactionSuccess.vue'
import TransactionCancelled from './../components/TransactionCancelled.vue'
import ImageInputChoice from './../components/ImageInputChoice.vue'
import ImageInputCamera from './../components/ImageInputCamera.vue'
import ImageInputUpload from './../components/ImageInputUpload.vue'
import Legal from './../components/Legal.vue'
import Upload from './../components/Upload.vue'
import SpendQuote from './../components/SpendQuote.vue'
import PaymentSpend from './../components/PaymentSpend.vue'
import PaymentSpendSuccess from './../components/PaymentSpendSuccess.vue'
import PaymentOtc from './../components/PaymentOtc.vue'
import PaymentOtcSuccess from './../components/PaymentOtcSuccess.vue'
import ProcHandler from './../components/ProcHandler.vue'
import CashInLocations from './../components/CashInLocations.vue'
import CreditCardFrame from './../components/CreditCardFrame.vue'
import CreditCardQuote from './../components/CreditCardQuote.vue'
import BankSelect from './../components/BankSelect.vue'
import FlowState from './../components/FlowState.vue'
import Idenfy from './../components/Idenfy.vue'
import Poli from './../components/Poli.vue'


const routes = [
    { name: '/', path: '/', component: ParamHandler },
    { name: 'verify', path: '/verify', component: Upload },
    { name: 'verify', path: '/verify/:country', component: Upload },
    { name: 'verify-pro', path: '/pro/verify', component: Upload },
    { name: 'transaction-type-currency-subtype', path: '/amount/:amount/cryptocurrency/:cryptocurrency/method/:method/type/:type/currency/:currency/subtype/:subtype', component: AmountInput },
    { name: 'transaction-type-currency', path: '/amount/:amount/cryptocurrency/:cryptocurrency/method/:method/type/:type/currency/:currency', component: AmountInput },
    { name: 'transaction-type', path: '/amount/:amount/cryptocurrency/:cryptocurrency/method/:method/type/:type', component: AmountInput },
    { name: 'credit-card-quote', path: '/credit-card-quote', component: CreditCardQuote },
    { name: 'credit-card-frame', path: '/credit-card', component: CreditCardFrame },
    { name: 'transaction', path: '/amount/:amount/cryptocurrency/:cryptocurrency/method/:method', component: AmountInput },
    { name: 'transaction-pro', path: '/pro/:customerHash', component: AmountInput },
    { name: 'transaction-new', path: '/transaction', component: InputForm },
    { name: 'price-quote', path: '/price-quote', component: PriceQuote },
    { name: 'address-input', path: '/address-input', component: AddressInput },
    { name: 'email-input', path: '/email-input', component: EmailInput },
    { name: 'buyer-info-input', path: '/buyer-info-input', component: BuyerInfoInput },
    { name: 'mobile-verification', path: '/mobile-verification', component: MobileVerification },
    { name: 'image-input-choice', path: '/image-input-choice', component: ImageInputChoice },
    { name: 'image-input-camera', path: '/image-input-camera', component: ImageInputCamera },
    { name: 'image-input-upload', path: '/image-input-upload', component: ImageInputUpload },
    { name: 'payment-etransfer-instructions', path: '/payment-etransfer-instructions', component: PaymentEtransferInstructions },
    { name: 'payment-flexepin', path: '/payment-flexepin', component: PaymentFlexepin },
    { name: 'payment-spend', path: '/payment-spend', component: PaymentSpend },
    { name: 'payment-spend-success', path: '/payment-spend-success', component: PaymentSpendSuccess },
    { name: 'transaction-in-review', path: '/transaction-in-review', component: TransactionInReview },
    { name: 'transaction-success', path: '/transaction-success', component: TransactionSuccess },
    { name: 'transaction-cancelled', path: '/transaction-cancelled', component: TransactionCancelled },
    { name: 'privacy-policy', path: '/privacy-policy', component: Legal },
    { name: 'terms-of-service', path: '/terms-of-service', component: Legal },
    { name: 'compliance-policy', path: '/compliance-policy', component: Legal },
    { name: 'refund-policy', path: '/refund-policy', component: Legal },
    { name: 'spend-quote', path: '/spend-quote', component: SpendQuote },
    { name: 'payment-otc', path: '/payment-otc', component: PaymentOtc },
    { name: 'payment-otc-success', path: '/payment-otc-success', component: PaymentOtcSuccess },
    { name: 'proc-handler', path: '/proc/:procid', component: ProcHandler },
    { name: 'cash-in-locations', path: '/cash-in-locations', component: CashInLocations },
    { name: 'bank-select', path: '/bank-select', component: BankSelect },
    { name: 'state', path: '/state/:refId', component: FlowState },
    { name: 'verify-idenfy', path: '/verify-idenfy/:token', component: Idenfy },
    { name: 'poli', path: '/poli', component: Poli },

    { path: '*', redirect: '/' },
]

export default routes